import {
  languageBuilder
} from "./builder.js";
const anime_airing = {
  UNIT_SINGULAR: `anime`,
  UNIT_PLURAL: `animes`,
  UNIT_SHORT: `Anime`,
  SUBUNIT_SINGULAR: `episodio`,
  SUBUNIT_PLURAL: `episodios`,
  SUBUNIT_SHORT: `ep.`,
  SUBUNIT_VERB_FUTURE: `se transmitir\xE1`,
  SUBUNIT_VERB_PAST: `se transmiti\xF3`
};
const anime_bluray = {
  UNIT_SINGULAR: `serie`,
  UNIT_PLURAL: `series`,
  UNIT_SHORT: `Serie`,
  SUBUNIT_SINGULAR: `volumen`,
  SUBUNIT_PLURAL: `vol\xFAmenes`,
  SUBUNIT_SHORT: `Vol.`,
  SUBUNIT_VERB_FUTURE: `se estrenar\xE1`,
  SUBUNIT_VERB_PAST: `se estren\xF3`
};
const manga_chapter = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `mangas`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `cap\xEDtulo`,
  SUBUNIT_PLURAL: `cap\xEDtulos`,
  SUBUNIT_SHORT: `Cap.`,
  SUBUNIT_VERB_FUTURE: `se estrenar\xE1`,
  SUBUNIT_VERB_PAST: `se estren\xF3`
};
const manga_volume = {
  UNIT_SINGULAR: `manga`,
  UNIT_PLURAL: `mangas`,
  UNIT_SHORT: `Manga`,
  SUBUNIT_SINGULAR: `tomo`,
  SUBUNIT_PLURAL: `tomos`,
  SUBUNIT_SHORT: `Tomo`,
  SUBUNIT_VERB_FUTURE: `se publicar\xE1`,
  SUBUNIT_VERB_PAST: `se public\xF3`
};
const strings = {
  ALL_COMPLETE: `\xA1No hay proyectos en curso!`,
  CONNECTION_ERROR: `Error de conexi\xF3n`,
  CONFIG_HEADER: `Configuraci\xF3n`,
  WEBSITE_SETTINGS_HEADER: `Par\xE1metros del sitio`,
  APP_URL: `La URL de tu aplicaci\xF3n`,
  LINK_PAGE: `Ir a la p\xE1gina`,
  PAGE_BGCOLOR: `Color principal del fondo del sitio`,
  NO_COLOR: `Ignonar el color de fondo`,
  RECOMMENDED_BGCOLOR: `Color de fondo recomendado`,
  OVERRIDE_BGCOLOR: `Ignorar recomendaci\xF3n`,
  THEME_HEADER: `Tema de color`,
  THEME_LIGHT: `Claro`,
  THEME_DARK: `Oscuro`,
  SIZE_HEADER: `Elecci\xF3n de tama\xF1o`,
  SIZE_SMALL: `Compacto (no recomendado)`,
  SIZE_NORMAL: `Normal`,
  ACCENT_HEADER: `Color de \xE9nfasis`,
  ACCENT_RED: `Rojo`,
  ACCENT_YELLOW: `Amarillo`,
  ACCENT_GREEN: `Verde`,
  ACCENT_BLUE: `Azul`,
  ACCENT_INDIGO: `\xCDndigo`,
  ACCENT_PURPLE: `Morado`,
  ACCENT_PINK: `Rosa`,
  ACCENT_NONE: `Ninguno`,
  LANGUAGE_HEADER: `Idioma`,
  EMBED_HEADER: `C\xF3digo incrustable para Wordpress`,
  EMBED_DESCRIPTION: `Redimensionar el iframe tras la carga`,
  EMBED_SHOW: `Mostrar c\xF3digo incrustable`,
  EMBED_HIDE: `Ocultar c\xF3digo incrustable`,
  ALL_POSITIONS: `Todos los puestos del staff`,
  EXAMPLE_ERROR: `Este ejemplo de error`,
  EXAMPLE_STATUS: `Este es un ejemplo de mensaje de estado opcional`,
  UNIT_JOINT_WITH: `En colaboraci\xF3n con {0}`,
  UNIT_SHOW_LESS: `Mostrar menos`,
  UNIT_SHOW_LESS_PLURAL: void 0,
  UNIT_SHOW_REMAINDER_SINGULAR: `Mostrar el %SUBUNIT_SINGULAR% restante...`,
  UNIT_SHOW_REMAINDER_PLURAL: `Mostrar los {1} %SUBUNIT_PLURAL% restantes...`,
  UNIT_UPDATED: `Actualizado {2}`,
  SUBUNIT_NOT_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_FUTURE% {1}`,
  SUBUNIT_WAS_PUBLISHED: `El %SUBUNIT_SHORT% {0} %SUBUNIT_VERB_PAST% {1}`,
  SUBUNIT_TO_RELEASE: `%SUBUNIT_SHORT% {0} est\xE1 listo para ser publicado`,
  SUBUNIT_IN_PROGRESS: `Al %SUBUNIT_SHORT% {0} le falta: {2}`,
  SUBUNIT_NO_PROGRESS: `(a\xFAn no hay progreso)`
};
import es from "../../_snowpack/pkg/javascript-time-ago/locale/es.json.proxy.js";
const lang = {
  locale: es,
  strings
};
export default {
  anime_airing: languageBuilder(lang, anime_airing),
  anime_bluray: languageBuilder(lang, anime_bluray),
  manga_chapter: languageBuilder(lang, manga_chapter),
  manga_volume: languageBuilder(lang, manga_volume)
};
//# sourceMappingURL=es.js.map
